import { useState, cloneElement, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import Dialog from "../../dialogs/Dialog";
import DropDownList from "../../forms/DropDownList";
import Sortable from "../../sortable/Sortable";
import Button from "../../buttons/Button";
import "./DialogSort.scss";

const SortableItemUI = (props) => {
  const { attributes, dataItem, columns, forwardRef, handleChange, removeSort } = props;

  const valueRender = (element, value) => {
    if (!value) {
      return element;
    }
    const children = [<span key={1} className={`k-icon k-font-icon ${value.icon}`}></span>, <span key={2}>&nbsp; {element.props.children}</span>];
    return cloneElement(
      element,
      {
        ...element.props,
      },
      children
    );
  };

  return (
    <div ref={forwardRef} {...attributes} className="col-12">
      <div className="k-form-field" key={dataItem.id}>
        <div className="reorder"></div>
        <DropDownList name={dataItem.id} textField="title" dataItemKey="field" data={columns} onChange={handleChange} value={dataItem} />
        <DropDownList name={dataItem.id} textField="textDir" dataItemKey="dir" data={_dirData} onChange={handleChange} value={dataItem} valueRender={valueRender} />
        <div>
          <Button onClick={() => removeSort(dataItem)} icon="close" />
        </div>
      </div>
    </div>
  );
};

const _initState = {
  sort: [],
  columns: [],
  allColumns: [],
  sortId: 0,
};
const _dirData = [
  { dir: "asc", textDir: "vzostupne", icon: "k-i-sort-asc-sm" },
  { dir: "desc", textDir: "zostupne", icon: "k-i-sort-desc-sm" },
];

/**
 * Sort in dialog
 * @module
 * @param {bool} isOpen - Is dialog open?
 * @param {func} handleCloseSort - Functions to close dialog
 * @param {func} handleCloseSort - Functions to confirm dialog
 * @param {array} sort - Sort
 * @param {array} schema - Schema
 */
const DialogSort = (props) => {
  const { isOpen, handleCloseSort, handleConfirmSort, sort, schema } = props;
  const [state, setState] = useState(_initState);

  const onDragOver = (event) => {
    setState(prev => ({ ...prev, sort: event.newState }));
  };

  const onNavigate = (event) => {
    setState(prev => ({ ...prev, sort: event.newState }));
  };

  const prerareData = useCallback(() => {
    let sortId = 0;
    const allColumns = schema
      .map((col) => (col.sortable === false ? null : { field: col.field + (col.filter === "container" ? "." + col.textField : ""), title: col.title, orderSort: col.orderSort }))
      .sort((a, b) => {
        const aNull = a.orderSort === null || a.orderSort === undefined;
        const bNull = b.orderSort === null || b.orderSort === undefined;
        if ((a.orderSort === b.orderSort) || (aNull && bNull)) {
          return a.title.localeCompare(b.title);
        }
        return aNull ? 1 : bNull ? -1 : a.orderSort - b.orderSort;
      });
    let newSort = sort.map((item) => ({
      id: sortId++,
      ...item,
      title: allColumns.find((col) => col.field === item.field).title,
      textDir: _dirData.find((el) => el.dir === item.dir).textDir,
      icon: _dirData.find((el) => el.dir === item.dir).icon,
    }));
    const columns = allColumns.filter((col) => !newSort.some((el) => el.field === col.field));

    if (newSort.length === 0) {
      newSort = [{ id: sortId++, ..._dirData[0] }];
    }

    setState(prev => ({ ...prev, sort: newSort, allColumns, columns, sortId }));
  }, [sort, schema])

  useEffect(() => {
    if (isOpen) {
      prerareData();
    }
  }, [isOpen, prerareData]);

  const confirmSort = () => {
    const sort = state.sort.filter((item) => item.field).map(({ id, title, textDir, icon, ...item }) => item);
    handleConfirmSort(sort);
  };

  const removeSort = (item) => {
    const sort = state.sort.filter((el) => el !== item);
    const columns = state.allColumns.filter((col) => !sort.some((el) => el.field === col.field));
    setState(prev => ({ ...prev, sort, columns }));
  };

  const handleChange = (id, value) => {
    const sort = state.sort.map((item) => (item.id === id ? { ...item, ...value } : item));
    const columns = state.allColumns.filter((col) => !sort.some((el) => el.field === col.field));
    setState(prev => ({ ...prev, sort, columns }));
  };

  const handleAddNewSort = () => {
    setState(prev => ({ ...prev, sort: [...prev.sort, { id: prev.sortId, ..._dirData[0] }], sortId: prev.sortId + 1 }));
  };

  return (
    <Dialog isOpen={isOpen} onClose={handleCloseSort} onConfirm={confirmSort} title="Zoradenie">
      <div className="dialog-sort">
        <div className="k-form-inline order-wraper">
          <div className="order">
            {state.sort.map((item, index) => (
              <div key={index}>{index + 1}</div>
            ))}
          </div>

          {state.sort.length > 0 && (
            <Sortable
              idField="id"
              SortableItemUI={(e) =>
                SortableItemUI({
                  ...e,
                  handleChange: handleChange,
                  removeSort: removeSort,
                  columns: state.columns,
                })
              }
              data={state.sort}
              onDragOver={onDragOver}
              onNavigate={onNavigate}
            />
          )}
        </div>
        <div className="sort-toolbar">
          <div className="left">
            <Button onClick={handleAddNewSort} icon="add" disabled={state.columns.length === 0} title="Pridať" />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

DialogSort.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleCloseSort: PropTypes.func.isRequired,
  handleConfirmSort: PropTypes.func.isRequired,
  sort: PropTypes.array.isRequired,
  schema: PropTypes.array,
};

export default DialogSort;
